import React from 'react';
import { inject, observer } from 'mobx-react';
import H5FeedbackFilter from './h5';
import PCFeedbackFilter from './pc';
import type { AppStore } from '@stores/app/store';
import type { FeedbackProductCategory, FeedbackProductItem, FetchProductsParams } from '@components/feedbackProductPicker';
import type { FeedbackProblemCategory, FeedbackProblemItem } from '@components/feedbackProblemPicker';

export interface FeedbackFilterOption {
    name: string;
    id: string | number;
    value: string;
    feedbackCount?: number;
    solvedCount?: number;
}

/** 问题反馈列表筛选参数，对应 GET /api/v5/feedbacks 的 filter 字段 */
export interface FeedbackFilterParams {
    searchValue: string;
    solveState: string;
    problemId: string;
    productId: string;
    daysValue: string;
    mine: string;
}

export interface FeedbackListRequestParams {
    'filter[days]'?: string;
    'filter[keywords]'?: string;
    'filter[mine]'?: string;
    'filter[problemId]'?: number;
    'filter[productId]'?: number;
    'filter[solveState]'?: number;
    'page[number]'?: number;
    'page[size]'?: number;
    [property: string]: any;
}

interface FeedbackFilterProps {
    app?: AppStore;
    filterParams: FeedbackFilterParams;
    searchInputValue: string;
    solveStateList: FeedbackFilterOption[];
    problemList: FeedbackFilterOption[];
    problemCategories: FeedbackProblemCategory[];
    productList: FeedbackFilterOption[];
    productCategories: FeedbackProductCategory[];
    daysList: FeedbackFilterOption[];
    totalCount?: number;
    layoutStyles?: Record<string, string>;
    onSearchChange?: (value: string) => void;
    onSearchConfirm?: () => void;
    onFilterChange?: (key: keyof FeedbackFilterParams, value: string) => void;
    onAdvancedFilterConfirm?: (values: Pick<FeedbackFilterParams, 'solveState' | 'daysValue'>) => void;
    onProblemSelect?: (problem: FeedbackProblemItem | null) => void;
    onProductSelect?: (product: FeedbackProductItem | null) => void;
    fetchProducts?: (params: FetchProductsParams) => Promise<FeedbackProductItem[]>;
    showSearchBar?: boolean;
    onSearchBack?: () => void;
}

/** 问题反馈列表筛选组件：PC / H5 按平台分发不同 UI */
@inject('app')
@observer
class FeedbackFilter extends React.Component<FeedbackFilterProps> {
    render() {
        const { app, ...props } = this.props;
        const platform = app?.platform || 'h5';
        if (platform === 'pc') {
            return <PCFeedbackFilter {...props} />;
        }
        return <H5FeedbackFilter {...props} />;
    }
}

export default FeedbackFilter;
